import api from '../api/apiClient';

export interface AuditLogEntry {
  _id: string;
  actorId?: string;
  actorType: 'client' | 'stylist' | 'admin' | 'system';
  actorEmail?: string;
  actorName?: string;
  targetUserId?: string;
  targetUserType?: 'client' | 'stylist' | 'admin';
  targetEmail?: string;
  targetName?: string;
  category: string;
  action: string;
  description: string;
  details: Record<string, unknown>;
  ipAddress?: string;
  userAgent?: string;
  createdAt: string;
}

export interface AuditTrailsResponse {
  success: boolean;
  data: AuditLogEntry[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

export interface AuditActionsResponse {
  success: boolean;
  data: { categories: string[]; actions: string[] };
}

export interface AuditTrailsParams {
  page?: number;
  limit?: number;
  actorType?: string;
  targetUserType?: string;
  category?: string;
  action?: string;
  userId?: string;
  email?: string;
  dateFrom?: string;
  dateTo?: string;
}

export async function getAuditTrails(params: AuditTrailsParams = {}): Promise<AuditTrailsResponse> {
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== '') {
      searchParams.append(key, String(value));
    }
  });
  const query = searchParams.toString();
  const url = query ? `/audit-trails?${query}` : '/audit-trails';
  const { data } = await api.get(url);
  return data as AuditTrailsResponse;
}

export async function getAuditActions(): Promise<AuditActionsResponse> {
  const { data } = await api.get('/audit-trails/actions');
  return data as AuditActionsResponse;
}
